import React from 'react'
import { channelById, channelByName } from '../constants/Channels'
import { buildPublicResourceUrl } from '../utils/images'

export const ChannelIcon = ({ channelId, channelName }: { channelId?: any; channelName?: any }) => {
  // legacy
  const channel = channelName ? channelByName(channelName) : channelById(channelId)
  return <img className="channel-icon" alt={channel.name} src={buildPublicResourceUrl(channel.iconUrl)} />
}

export default ChannelIcon
